import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import PlansSubscription from './PlansSubscription'
import FormSubscription from './FormSubscription'
import axios from './../../config/axiosInstance';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: '20px',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

function getSteps() {
    return ['Planos', 'Formulário'];
}

export default function NewSubscription({ values, step, closeAviso }) {

    const classes = useStyles();
    const [mule, setMule] = React.useState(true);
    const [companyData, setCompanyData] = React.useState({});
    const [activeStep, setActiveStep] = React.useState(step == 1 ? step : 0);
    const [checked, setChecked] = React.useState(false);
    const [planSelected, setPlanSelected] = React.useState();
    const [cupom, setCupom] = React.useState('');
    const steps = getSteps();

    const companyInfo = React.useCallback(async () => {
        const response = await axios.get('/companyData');
        setCompanyData(response.data);
    }, []);

    React.useEffect(() => {
        // window.gtag('event', 'conversion', { send_to: 'AW-767300505/6csuCKyB-rwYEJmn8o0C' });
        companyInfo();
        getCupom();
    }, [companyInfo]);

    const getCupom = (plans) => {
        const url = new URL(window.location.href);
        const cupom = url.searchParams.get("Cupom");
        if (cupom != '' && mule) {
            setCupom(cupom)
        }
    };

    const [state, setState] = React.useState({
        values: {
            name: '',
            document: '',
            phone: '',
            email: '',
            zipCode: '',
            address: '',
            addressNumber: '',
            complement: '',
            district: '',
            city: '',
            state: '',
            ticket: '',
            municipalInscription: '',
            creditCard: {
                number: '',
                name: '',
                cvc: '',
                expiry: '',
            }
        },
    });

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);

    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const urlplan = (plans) => {
        const url = new URL(window.location.href);
        const planUrl = url.searchParams.get("plan");
        const pagamentoUrl = url.searchParams.get("Pagamento");
        if (planUrl == 'Light' && mule) {
            setPlanSelected(plans.offers.find(i => i.id == 11));
            setChecked(pagamentoUrl == 'false' ? false : true);
            handleNext();
            setMule(false);
        }
        if (planUrl == 'Premium' && mule) {
            setPlanSelected(plans.offers.find(i => i.id == 13));
            setChecked(pagamentoUrl == 'false' ? false : true);
            handleNext();
            setMule(false);
        }
        if (planUrl == 'Enterprise' && mule) {
            setPlanSelected(plans.offers.find(i => i.id == 17));
            setChecked(pagamentoUrl == 'false' ? false : true);
            handleNext();
            setMule(false);
        }
    };

    function getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return <PlansSubscription
                    handleNext={handleNext}
                    checked={checked}
                    setChecked={setChecked}
                    setPlanSelected={setPlanSelected}
                    urlplan={urlplan} />;
            case 1:
                return <FormSubscription
                    companyData={companyData}
                    values={state.values}
                    cupom={cupom}
                    setState={setState}
                    onChangeValue={(name, value) => setState({ ...state, [name]: value })}
                    handleNext={handleNext}
                    checked={checked}
                    planSelected={planSelected} />;

        }
    }


    return (
        <Paper className={classes.root}>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            <div>
                {activeStep === steps.length ? (
                    <div>
                        <Typography className={classes.instructions}>All steps completed</Typography>
                        <Button onClick={handleReset}>Reset</Button>
                    </div>
                ) : (
                    <div>
                        <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
                        {activeStep != 0 ?
                            <div>
                                {step == 1 ? <Button onClick={closeAviso}>
                                    SAIR
                                </Button> :
                                    <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        className={classes.backButton}
                                    >
                                        Voltar
                                    </Button>
                                }
                            </div> : ''}
                    </div>
                )}
            </div>
        </Paper>
    );
}